import SectionEmotoHero from './SectionEmotoHero';

export default SectionEmotoHero;
